import React, { useEffect, useState, useRef } from "react";
import {getLastSession,getLastUser,getDashboardInfo,getDeviceSerials,getCurrentDeviceSerial, 
        setCurrentDeviceSerial, userHasAddlDevices, getUserDeviceSerials} from '../Data/SessionData.js';
import ReactDOM from 'react-dom';

export default function PageHeader(props) {

  const [lut, setLut] = useState("");
  const [deviceSerial,setDeviceSerial] = useState(props.deviceSerial);  //getLastUser().deviceSerial);
  const [userType] = useState(getLastUser().userType);
  const [needSerialDropDown,setNeedSerialDropDown] = useState(userHasAddlDevices());  //getLastUser().deviceSerial);
  // const [selectedSerial, setSelectedSerial] = useState('');
  // const [allSerials, setAllSerials] = useState([
  //   '2302',
  //   '3504',
  //   '4504',
  // ]);    
  const handleOptionChange = (event) => {
    var selSer = event.target.value;
    console.log("Device Serial Changed to",selSer);
    // setSelectedSerial(selSer);
    setCurrentDeviceSerial(selSer);
    setDeviceSerial(selSer);
    if (props.callback) {
        props.callback(selSer);
    }
  };
  const renderDropdown = (allSerials) => {
    return (
      <select onChange={handleOptionChange}>
        {allSerials.map((option, index) => {
          const isSelected = option === deviceSerial;
          return (
          <option key={index} value={option} selected={isSelected}>
            {option}
          </option>
          );
        })}
      </select>
    );
  };

  useEffect(() => {
    var devSerialDiv = document.getElementById("deviceSerialDiv");
    console.log("User Type",userType);
    var listSerials = null;
    if (userType === 'admin') {
        setNeedSerialDropDown(true);
        listSerials = getDeviceSerials();
    }
    else
    if (userType !== 'admin' && needSerialDropDown) {
        listSerials = getUserDeviceSerials();
    }
    else {
      devSerialDiv.innerHTML = "Device Serial: "+deviceSerial;
    }
    if (listSerials != null) {
      const label = document.createElement('label');
      label.textContent = 'Select Serial';
      devSerialDiv.appendChild(label);
      const dropdownContainer = document.createElement('div');
      ReactDOM.render(renderDropdown(listSerials), dropdownContainer);
      devSerialDiv.appendChild(dropdownContainer);
    }
  }, []);

  useEffect(() => {
    if (!props) return;
    if (!props.LastUpdatedDate) return;
    setLut(props.LastUpdatedDate);
  }, [props]);

  useEffect(() => {
    var chartDom = document.getElementById("lutDateTime");
    chartDom.innerHTML = lut;
  }, [lut]);

  function handleResetButton() {
    console.log("handleResetButton");
  }
  function chartPlace() {
    /*
    var visitorsSparcalChart = echarts.init(chartDom);
    var option;
    option = visitorsSparcalOption;

    option && visitorsSparcalChart.setOption(option);
    */
  };

  function chartPlace1() {
    /*
    var visitsSparcalChart = echarts.init(chartDom);
    var option;
    option = visitsSparcalOption;

    option && visitsSparcalChart.setOption(option);
    */
  };

  const { HeaderText, Breadcrumb, LastUpdatedDate } = props;
    return (
      <div className="block-header">
        <div className="row">
          <div className="col-lg-5 col-md-6 col-sm-12">
            <h2>
              <a
                href="#!"
                className="btn btn-xs btn-link btn-toggle-fullwidth"
                onClick={(e) => {
                  e.preventDefault();
                }}
              >
                <i
                  className={
                    `fa fa-arrow-left`
                  }
                ></i>
              </a>{" "}
              {HeaderText}
            </h2>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="dashboard">
                  <i className="icon-home"></i>
                </a>
              </li>
              {Breadcrumb.map((item, index) => {
                return (
                  <li
                    key={item.name + index}
                    className="breadcrumb-item active"
                  >
                    <a href={item.navigate ? item.navigate : null}>
                      {item.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="col-lg-7 col-md-4 col-sm-12 text-right">
            {/*
              <a href="#!"
                className="btn btn-xs btn-link btn-toggle-fullwidth" style={{ float: "right" }}
                onClick={(e) => {
                  e.preventDefault();handleResetButton();
                }}
              >
            <img className="sparkline text-right" src="/images/reset-button.png"/>
            </a>
            <br/><br/>
              */}
            <div id="deviceSerialDiv" className="sparkline text-right"
                style={{ width: "24vh", height: 25, color: "blue", float: "right", verticalAlign:"middle" }}>                  
            </div>
            <div className="inlineblock text-center m-r-15 m-l-15 hidden-sm">
              <span>Last Update:</span>
            </div>
            <div className="inlineblock text-center m-r-15 m-l-15 hidden-sm">
              <div
                className="sparkline text-right"
                style={{ width: "24vh", height: 25 }}></div>
              <span id="lutDateTime">NA</span>
            </div>
          </div>
        </div>
      </div>
    );
}
